import * as React from 'react';
import { PCImage } from 'app/design/primitives/image';
import { images } from 'app/design/images';

export default function IntroBorrow({ width = 317, height = 216 }: { width?: number; height?: number }) {
  return <PCImage height={height} source={images.introBorrow} width={width} />;
}
